import { render } from "./BrandPresence.vue?vue&type=template&id=747330de&scoped=true"
import script from "./BrandPresence.vue?vue&type=script&lang=js"
export * from "./BrandPresence.vue?vue&type=script&lang=js"

import "./BrandPresence.vue?vue&type=style&index=0&id=747330de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747330de"]])

export default __exports__